<template>
  <div>
    <sale-plan-compnay-list v-show="action === 'list'" @change-action="changeAction" />
    <sale-plan-compnay-detail v-if="action === 'detail'" :plan-num="planNum" @change-action="changeAction" />
  </div>
</template>

<script>
import SalePlanCompnayList from './components/SalePlanCompnayList.vue'
import SalePlanCompnayDetail from './components/SalePlanCompnayDetail.vue'
export default {
  components: {
    SalePlanCompnayList,
    SalePlanCompnayDetail
  },
  data() {
    return {
      action: 'list',
      planNum: ''
    }
  },
  methods: {
    changeAction(type, planNum) {
      this.action = type
      this.planNum = planNum || ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanQueryCompany.vue